/**
 * lativ — Tamanhos no hover do card (estilo SetActive)
 * Clique num tamanho → adiciona a variante à sacola via /cart/add.js
 * e dispara cart:update (mesmo evento usado pelo Rook UI, que o
 * drawer do Horizon já escuta).
 *
 * Listener em fase de captura para vencer o link do card.
 */
document.addEventListener(
  'click',
  async function (e) {
    var btn = e.target.closest('.lativ-quick-sizes__btn');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    e.stopPropagation();

    btn.classList.add('is-loading');
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add falhou: ' + res.status);

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'lativ-quick-sizes' } },
        })
      );

      // abre o drawer da sacola (o showDialog do componente depende de
      // estado interno; o showModal nativo do <dialog> é o fallback)
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        var dialog = drawer.querySelector('dialog');
        if (dialog && !dialog.open) {
          try { dialog.showModal(); } catch (openErr) { /* já aberto */ }
        }
      }

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(function () {
        btn.classList.remove('is-added');
      }, 1500);
    } catch (err) {
      console.error('[lativ-quick-sizes]', err);
      btn.classList.remove('is-loading');
    }
  },
  true
);
